const appHeight = () => {
	const doc = document.body;
	doc.style.setProperty('--app-height', `${window.innerHeight}px`);
};
export function initScreenHeight() {
	let timeout: any = false;
	window.addEventListener('resize', () => {
		// clear the timeout
		clearTimeout(timeout);
		// start timing for event "completion"
		timeout = setTimeout(appHeight, 100);
	});
	appHeight();
}



// WEBPACK FOOTER //
// ./scripts/helpers/screenHeight.ts